export default function SET_EXTERNAL_EXPERTS(state, payload) {
  state.externalExperts.current = payload.origin.externalExperts;
}
